import React from 'react';
import { Link, Typography, List, ListItem } from '@mui/material';

const Community = () => (
  <article className="community">
    <h1>Onboard Data Expert Community</h1>
    <Typography variant="body1">
      A space designed for you to connect with other Onboard users, share insights, and find
      resources that support your journey with us.
      <br />
      In this community, you will be able to:
      <List sx={{ listStyleType: 'disc' }}>
        <ListItem sx={{ display: 'list-item' }}>
          <strong>Explore resources</strong> for setup guidance and product tips.
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          <strong>Engage in discussions</strong> with fellow users and our team.
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          <strong>Get exclusive updates</strong> and share feedback to shape our product.
        </ListItem>
      </List>
      <strong>
        Not a member yet?{' '}
        <Link
          color="textPrimary"
          underline="hover"
          href="https://onboard.discourse.group/invites/Yvagmu9djA"
        >
          Join Here
        </Link>
        <p />
        Already a member?{' '}
        <Link color="textPrimary" underline="hover" href="https://onboard.discourse.group/login">
          Log In Here
        </Link>
      </strong>
    </Typography>
  </article>
);

export default Community;
